import React from 'react';
import { Body } from '@edreamsodigeo/prisma-design-system';
import { useBrand } from '@edreamsodigeo/frontend-core';

import { useBrandColor } from '~clientState/hooks';

export interface HighlightTextProps {
  isPrime?: boolean;
  color?: string;
  weight?: 'normal' | 'medium' | 'bold';
  children?: React.ReactNode;
  type?: 'base' | 'small' | 'xSmall' | 'xxSmall';
}

const HighlightText = ({
  isPrime = false,
  children,
  color,
  weight,
  type,
}: HighlightTextProps) => {
  const brand = useBrand();
  const { textColor } = useBrandColor({ brand, isPrime });

  return (
    <Body color={color || textColor} weight={weight} inline type={type}>
      {children}
    </Body>
  );
};

export default HighlightText;
